/** How long the "copied" confirmation stays up, in ms. */
export const COPIED_FEEDBACK_MS = 1500;

export const I18N_PREFIX = 'conversationDetail';
